module.exports = __webpack_public_path__ + "/images/logo-ico-bizum-full.7db9e84.svg";